import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { filterPrimaryConfig } from 'page/layout-areas.js';
import * as React from 'react';
import { ILayoutConfig } from 'redux-state/layout/types.layout.js';
import { RenderLargeLayout } from './five-up-large.js';
import { RenderSmallLayout } from './five-up-small.js';

const FiveUpPrimarySection = ({ data }: { data: ILayoutConfig }) => {
  const columnLayout = React.useContext(ColumnLayoutContext);
  return <FiveUpPrimarySectionCore columnLayout={columnLayout} data={data} />;
};

const FiveUpPrimarySectionCore = ({
  data,
  columnLayout,
}: {
  data: ILayoutConfig;
  columnLayout: '1-column' | '2-column' | '3-column';
}) => {
  const { primary } = data;
  const isLarge = columnLayout !== '1-column';

  const filteredPrimaryConfig = React.useMemo(
    () => filterPrimaryConfig(primary.slots, columnLayout),
    [primary.slots, columnLayout],
  );

  if (data) {
    if (isLarge) {
      return <RenderLargeLayout filteredPrimaryConfig={filteredPrimaryConfig} columnLayout={columnLayout} />;
    }

    return <RenderSmallLayout filteredPrimaryConfig={filteredPrimaryConfig} />;
  }
  return null;
};

export const FiveUpPrimary = React.memo(FiveUpPrimarySection);
